import Pusher from 'pusher-js'

const pusher = new Pusher(import.meta.env.VITE_REVERB_APP_KEY, {
  wsHost: import.meta.env.VITE_REVERB_HOST,
  cluster: '',
  wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
  wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  disableStats: true,
  enabledTransports: ['ws', 'wss']
})

export default pusher
